module.exports = require("@ont-community/hdkey-secp256r1");